import {
  trigger,
  animate,
  transition,
  style,
  state
} from '@angular/animations';

export const menuSlide = trigger('menuSlide', [
  state('closed', style({ transform: 'translate3d(0%, calc(-3em - 100%), 0)', opacity: 1 })),
  state('open', style({ transform: 'translateX(0)', opacity: 1 })),
  transition('closed <=> open', animate('300ms ease-in-out')),
]);